<template>
  <div class="">
    <div class="row">
      <div class="col-md-12 col-sm-8">
        <div class="card card-default widget animated">
          <div class="card-heading">
            <div class="row">
              <div class="col-md-4">
                <input class="form-control pull-right" type="search" placeholder="Search Users" id="example-search-input" v-model="searchQuery">
              </div>
              <div class="col-md-2" v-if="org['curOrg']['role'] == '1' || org['curOrg']['role'] == 99">
                <router-link class="btn btn-success" to="/admin/user/create">Add</router-link>
              </div>
            </div>
            <br/>
            <data-table :data="users" :columns="columns" :filter-key="searchQuery"></data-table>
          </div>
        </div>
      </div><!-- /.col-md-12 -->
      </div><!-- /.col-md-3 -->
    </div>
  </div>
</template>

<script>
import DataTable from './UsersTable'
import database from '../../webmaster/Database/database'
import store from '../../webmaster/Store/vuex'

export default {
  name: 'users',
  components: {
    'data-table': DataTable
  },
  data () {
    return {
      searchQuery: '',
      columns: ['name', 'email alerts', 'more'],
      users: [],
      org: store.state.usermain,
    }
  },
  created:function(){
    //Populate users
    var self = this
    var ref = '/orgs/' + this.$store.state.usermain.curOrg.id + '/users'
    this.$bindAsArray('users', database.getRef(ref));
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// Users.vue?b5566424